import { __exports as fixOptions } from "./index149.js";
var hasRequiredFixOptions;
function requireFixOptions() {
  if (hasRequiredFixOptions) return fixOptions;
  hasRequiredFixOptions = 1;
  Object.defineProperty(fixOptions, "__esModule", {
    value: true
  });
  fixOptions.default = fixOptions$1;
  function fixOptions$1(options) {
    options.marginTop = options.marginTop || options.margin;
    options.marginBottom = options.marginBottom || options.margin;
    options.marginRight = options.marginRight || options.margin;
    options.marginLeft = options.marginLeft || options.margin;
    return options;
  }
  return fixOptions;
}
export {
  requireFixOptions as __require
};
//# sourceMappingURL=index129.js.map
